var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-step pfb-reg",
      class: [
        !_vm.isSimple && "is-" + _vm.$parent.direction,
        _vm.isSimple && "is-simple",
        _vm.isLast && !_vm.space && !_vm.isCenter && "is-flex",
        _vm.isCenter && !_vm.isVertical && !_vm.isSimple && "is-center"
      ],
      style: _vm.style
    },
    [
      _vm.stepType == "big"
        ? _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-col",
                { staticStyle: { "max-width": "120px" }, attrs: { span: 23 } },
                [
                  _c(
                    "div",
                    { staticClass: "ovr-step-main", class: _vm.getStatusClass },
                    [
                      _c("div", { staticClass: "ovr-step-submain" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mb-2 mt-1",
                            staticStyle: { "font-size": "30px" }
                          },
                          [_vm._v(_vm._s(_vm.index + 1))]
                        ),
                        _vm._v(" "),
                        _c("div", { style: _vm.titleStyle }, [
                          _vm._v(_vm._s(_vm.title))
                        ])
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.isLast
                ? _c(
                    "el-col",
                    {
                      staticClass: "ovr-step__line",
                      staticStyle: { width: "-webkit-fill-available" },
                      style: _vm.isLast
                        ? ""
                        : { marginRight: _vm.$parent.stepOffset + "px" },
                      attrs: { span: 1 }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { height: "120px" },
                          attrs: {
                            type: "flex",
                            justify: "center",
                            align: "middle"
                          }
                        },
                        [_c("i", { staticClass: "fas fa-circle" })]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.stepType == "small"
        ? _c("div", [
            _c("div", { staticClass: "el-step__head" }, [
              _c(
                "div",
                { staticClass: "el-step__line", style: _vm.getLineStyle },
                [
                  _c("i", {
                    staticClass: "el-step__line-inner",
                    style: _vm.lineStyle
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "el-step__icon ovr-step-icon",
                  class: "is-" + (_vm.icon ? "icon" : "text"),
                  style: _vm.getIconStyle
                },
                [
                  _vm.currentStatus !== "success" &&
                  _vm.currentStatus !== "error"
                    ? _vm._t("icon", function() {
                        return [
                          _vm.icon
                            ? _c("i", {
                                staticClass: "el-step__icon-inner",
                                class: [_vm.icon],
                                staticStyle: { color: "#fff" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.icon && !_vm.isSimple
                            ? _c(
                                "div",
                                { staticClass: "el-step__icon-inner" },
                                [_vm._v(_vm._s(_vm.index + 1))]
                              )
                            : _vm._e()
                        ]
                      })
                    : _c("i", {
                        staticClass: "el-step__icon-inner is-status ",
                        class: [
                          _vm.currentStatus === "success" ? "fas fa-circle" : ""
                        ],
                        staticStyle: { color: "#fff" }
                      })
                ],
                2
              ),
              _vm._v(" "),
              _vm.currentStatus === "process"
                ? _c(
                    "div",
                    { staticStyle: { width: "40px", "margin-left": "-10px" } },
                    [
                      _c("div", {
                        staticStyle: {
                          border: "1px solid #fff",
                          width: "0px",
                          height: "10px",
                          "margin-left": "auto",
                          "margin-right": "auto"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { color: "#fff", "font-size": "14px" } },
                        [
                          _vm._v(
                            _vm._s(_vm.index + 1) +
                              " " +
                              _vm._s(_vm.$tc("of")) +
                              " " +
                              _vm._s(_vm.stepsCount)
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }